<template>
  <v-container class="agenda-dia">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <PageTitle
        icon="mdi-pencil-box-outline"
        main="Agenda de eventos"
        sub="Eventos"
        home='/legislativo'
      />
      <div>
        <formulario />
      </div>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Formulario from '../agenda/index.vue'
// import Stat from './Stat'
// import axios from 'axios'
// import { baseApiUrl } from '../../global'
export default {
  name: 'AgendaDia',
  components: { PageTitle, Formulario },
  data: () => ({
  })
}
</script>

<style scoped>
</style>
